<button
  class="button-credito"
  [style.background]="bgColor"
  (mouseenter)="hovered = true"
  (mouseleave)="hovered = false; pressed = false"
  (mousedown)="pressed = true; setPressedColor()"
  (mouseup)="pressed = false"
  (click)="onClick.emit(); goToPortal()"
>
  <span [style.color]="textColor">{{ texto }}</span>
  <img [src]="getIconoActual()" alt="">
</button>
